import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSection } from 'omni-package-react-core';
import { FormCol, FormRow, Spacing, ToggleButtonListControl } from 'ia-react-core';
import { CommunicationPreference } from '../../../../interfaces/CommunicationPreference';
import { StyledToggleButtonListWrapper } from '../CommunicationPreferencesForm.styles';

export interface CommunicationPreferencesSectionProps {
  preference: CommunicationPreference;
}

const CommunicationPreferencesSection: FC<CommunicationPreferencesSectionProps> = ({ preference }) => {
  const { t } = useTranslation('CommunicationPreferencesFormPage');

  const options = [
    { label: t('communicationPreference.option1'), value: { ...preference, preferenceValue: 1 }, key: 'preferenceValue' },
    { label: t('communicationPreference.option2'), value: { ...preference, preferenceValue: 2 }, key: 'preferenceValue' },
  ];

  return (
    <FormSection pb={12} title={t('communicationPreference.sectionTitle')}>
      <Spacing m-t={36}>
        <FormRow>
          <FormCol label={t('communicationPreference.label')}>
            <StyledToggleButtonListWrapper>
              <ToggleButtonListControl
                name="communicationPreference"
                validate={(value) => ({
                  required: !value?.preferenceValue,
                })}
                defaultValue={preference}
                options={options}
              />
            </StyledToggleButtonListWrapper>
          </FormCol>
        </FormRow>
      </Spacing>
    </FormSection>
  );
};

export default CommunicationPreferencesSection;
